import React, { Component } from 'react';
import * as _ from 'lodash'
import './style.css';

import SurveyQuestion from '../SurveyQuestion'
import SurveySectionResultSlider from '../SurveySectionResultSlider'
import ExclamationSymbol from '../ExclamationSymbol'
import CloseButtonIcon from '../CloseButtonIcon'

import Logic from '../Logic'
import State from '../State'

class SurveySection extends Component {

  handleCloseButtonClick() {
    // State.action('nextSurveySection')
    State.action('openSurveySection', {sectionIndex: this.props.sectionIndex, sectionElement: this.sectionElement})
  }

  handleTitleClick() {
    State.action('openSurveySection', {sectionIndex: this.props.sectionIndex, sectionElement: this.sectionElement})
  }

  render() {
    // console.log(State.survey, this.props)
    const section = State.survey[this.props.sectionId]
    const questions = _.map(section.questions, question => {
      return <SurveyQuestion key={question.id} section={section} question={question} />
    })

    const sectionIsActive = this.props.sectionIndex ===  State.ui.surveyActiveSection
    const sectionIsVisible = State.ui.surveyActiveSection === null || sectionIsActive

    const surveySectionClasses = "survey-section" + (sectionIsVisible ? ' visible' : '') + (sectionIsActive ? ' active' : '')
    const surveySectionBodyClasses = "survey-section-body" + (sectionIsActive ? ' active' : '')

    // let nextButtonText = 'Next section'
    // if(this.props.isLastSection)
    //   nextButtonText = 'See your result'

    let numberUnanswered = Logic.numberOfUnansweredInSection(State.survey, this.props.sectionId)
    let statusText = sectionIsActive ? '' : numberUnanswered > 0 ? numberUnanswered + ' more questions >' : 'All answered'
    // let allQuestionsAnsweredInSection = Logic.allQuestionsAnsweredInSection(State.survey, this.props.sectionId)
    // let nextButtonClasses = "survey-section-next-button button" + (numberUnanswered === 0 ? ' active': '')

    let flagged = Logic.sectionContainsFlaggedQuestion(this.props.sectionId, State.derived.flaggedQuestions) ? <ExclamationSymbol r="14" /> : ''

    let reverseSlider = true //_.includes(['heating', 'ventilation', 'maintenance'], section.id)

    let sectionImagePath = `./img/categories/${section.id}.png`

    let closeButton
    if(sectionIsActive) {
      closeButton = <div className="survey-section-close-button"><CloseButtonIcon clickHandler={this.handleCloseButtonClick.bind(this)} /></div>
    }

          // {State.ui.explore ? '' : <div className={nextButtonClasses} onClick={this.handleNextButtonClick.bind(this)}>{nextButtonText}</div>}
          // {!State.ui.explore && sectionIsActive ? <div className="survey-section-description">{section.description}</div> : ''}
// {!State.ui.explore && !sectionIsActive ? <div className="survey-section-status">{statusText}</div> : ''}

    return (
      <div className={surveySectionClasses} ref={el => this.sectionElement = el}>

        {closeButton}

        <div className="survey-section-head" onClick={this.handleTitleClick.bind(this)}>
          <img src={sectionImagePath} alt="Sketch of the category" />
          <div className="survey-section-title">
            <div className="survey-section-name">{flagged}{section.name}</div>
            <div className="survey-section-description">{section.description}</div>
          </div>
          {numberUnanswered === 0 ? <SurveySectionResultSlider value={Logic.getNormalisedSubtotal(State.survey, 'chosenAnswer', section.id)} reverse={reverseSlider} /> : ''}
          {numberUnanswered > 0 ? <div className="survey-section-status">{statusText}</div> : null}
        </div>

        <div className={surveySectionBodyClasses}>
          <div className="survey-section-questions">{questions}</div>
        </div>

        <div className="survey-section-footer">
          {sectionIsActive && numberUnanswered === 0 ? <div className="button" onClick={this.handleCloseButtonClick.bind(this)}>Close section</div> : null}
        </div>
      </div>
    );
  }
}

export default SurveySection;



// WEBPACK FOOTER //
// ./src/SurveySection/index.js